export default "__VITE_ASSET__i1Onpmiv__"